
import { Location, LocationParams } from 'lib/componentLocation';

const hashRx = /^#?!?([^?]*)(?:\?([^?]*))?$/,
    queryItemRx = /^([^=]+)=([^=]*)$/;

export class HashComponentLocationParser {
    parse(str : string) : Location | null {
        let m = hashRx.exec(str);

        if (!m) return null;

        let [, name, queryStr] = m,
            params : LocationParams = {};

        if (queryStr) {
            queryStr.split('&').map(segment => queryItemRx.exec(segment))
                .filter(queryItem => queryItem)
                .map(queryItem => queryItem!.map(decodeURIComponent))
                .forEach(([, key, val]) => {
                    params[key] = val;
                });
        }

        return new Location(decodeURIComponent(name), params);
    }

    serialize(req : Location) : string {
        return '!' + encodeURIComponent(req.name)
        + Object.keys(req.params).map((k, i) => (i ? '&' : '?') + encodeURIComponent(k) + '=' + encodeURIComponent(req.params[k]!)).join('');
    }
}


// WEBPACK FOOTER //
// ./lib/hashComponentLocationParser.ts